<template>
  <button @click="click" class="button-cancel" :disabled="load">
    <slot>
	    Abbrechen
    </slot>
  </button>
</template>

<script setup>
const props = defineProps({load: Boolean});
const emits = defineEmits(['click']);
const click = () => emits('click');
</script>
